import React from "react";
import { Avatar, AvatarGroup, Box, Text } from "@chakra-ui/react";

export function TutorialAvatar({
  name,
  image,
}: {
  name?: string;
  image?: string;
}) {
  return (
    <>
      <Box pos="absolute" zIndex="1" bottom="5" right="0">
        <Box
          paddingLeft="2"
          paddingRight={image ? "8" : "2"}
          borderRadius="4"
          mr="2"
          bg="white"
          _dark={{ bg: "orange.300" }}
        >
          <Text
            _dark={{ color: "black" }}
            lineHeight="1.6em"
            fontSize="0.5em"
            textStyle="smallCaps"
          >
            Instructor-led
          </Text>
        </Box>
      </Box>
      {name && image && (
        <Box pos="absolute" right="-3" bottom="2">
          <AvatarGroup size="md">
            <Avatar zIndex="1" key={name} src={image} name={name} />
          </AvatarGroup>
        </Box>
      )}
    </>
  );
}
